import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css, injectGlobal } from 'styled-components';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import NotFound from '../../components/NotFound';
import SectionSeparator from '../../components/SectionSeparator';
import { __ } from '../../utilities';
import { MAX_PASSENGERS } from '../App/constants';
import { passengerCountSelector } from '../Passengers/selectors';
import { loadMyFavouritePassengers } from './actions';
import List from './List';
import {
  myFavouritePassengersIsFetchingSelector,
  myFavouritePassengersPassengersSelector,
} from './selectors';
import { favouritePassengersPropType } from './types';

const Wrapper = styled.div`
  padding: 1rem 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  overflow-y: scroll;
  padding-bottom: 7rem;
`;

const Container = styled.div`
  max-width: ${rem(801)};
  margin: auto;
`;

const LoaderWrapper = styled.div`
  margin: ${rem(10)} 0;
`;

const CountInfo = styled.div`
  font-size: ${rem(18)};
  text-align: center;
  margin-bottom: 1rem;
  ${({ warning }) =>
    warning &&
    css`
      color: ${({ theme }) => theme.color.danger};
    `};
`;

const ButtonWrapper = styled.div`
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 2rem;
`;

const BODY_OVERFLOW_CLASSNAME = 'favourite-passengers-opened';

// eslint-disable-next-line
injectGlobal`
    body.${BODY_OVERFLOW_CLASSNAME} {
        overflow: hidden;
    }
`;

class FavouritePassengers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadMyFavouritePassengers());
    document.body.classList.add(BODY_OVERFLOW_CLASSNAME);
  }

  componentWillUnmount() {
    document.body.classList.remove(BODY_OVERFLOW_CLASSNAME);
  }

  handleOnSelect = () => {
    const { passengers, onSelect } = this.props;
    const { selected } = this.state;
    onSelect(passengers.filter((passenger, idx) => selected.includes(idx)));
  };

  renderLoader = () => (
    <LoaderWrapper>
      <Loader
        size="xl"
        text={__('Hľadám ľudí, ktorí s Vami v minulosti cestovali ...')}
      />
    </LoaderWrapper>
  );

  renderPassengerList() {
    const { passengers, passengerCount } = this.props;
    if (!passengers) {
      return null;
    }
    if (passengers.length === 0) {
      return <NotFound title={__('Nenašli sme nikoho, kto s Vami cestoval')} />;
    }
    const selectedPassengerCount = passengerCount + this.state.selected.length;
    const isSelectable = selectedPassengerCount < MAX_PASSENGERS;
    return (
      <React.Fragment>
        <CountInfo warning={selectedPassengerCount >= MAX_PASSENGERS}>
          {__('Počet cestujúcich')} {selectedPassengerCount}/{MAX_PASSENGERS}
        </CountInfo>
        <List
          passengers={passengers}
          selectedIdxs={this.state.selected}
          selectable={isSelectable}
          onSelect={idx => {
            const selected = [...this.state.selected];
            const idxInArray = selected.indexOf(idx);
            if (idxInArray === -1) {
              if (isSelectable) {
                selected.push(idx);
              }
            } else {
              selected.splice(idxInArray, 1);
            }
            this.setState({ selected });
          }}
        />
      </React.Fragment>
    );
  }

  render() {
    const { isFetching, passengers, onClose } = this.props;
    return (
      <Wrapper>
        <Container>
          <SectionSeparator content={__('Obľúbení cestujúci')} />
          {isFetching && passengers === null
            ? this.renderLoader()
            : this.renderPassengerList()}
          <ButtonWrapper>
            <Button basic onClick={onClose}>
              {__('Späť')}
            </Button>
            <Button primary onClick={this.handleOnSelect}>
              {__('Pridať vybratých cestujúcich')}
            </Button>
          </ButtonWrapper>
        </Container>
      </Wrapper>
    );
  }
}

FavouritePassengers.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  passengers: favouritePassengersPropType,
  dispatch: PropTypes.func.isRequired,
  passengerCount: PropTypes.number.isRequired,
};

FavouritePassengers.defaultProps = {
  passengers: null,
};

const mapStateToProps = state => {
  return {
    isFetching: myFavouritePassengersIsFetchingSelector(state),
    passengers: myFavouritePassengersPassengersSelector(state),
    passengerCount: passengerCountSelector(state),
  };
};

export default connect(mapStateToProps)(FavouritePassengers);



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/index.js